var $=jQuery;
jQuery(document).ready(function ($) {
/** BUTTON CUSTOM */

$(document).on('click', 'a[href*="/pages/widerrufen"]', function (event) {
    console.log("2222");
  const pathname = new URL(this.href, window.location.origin).pathname;

  if (!pathname.endsWith('/pages/widerrufen')) return;

  event.preventDefault();
  event.stopPropagation();

  let attempts = 0;

  const timer = setInterval(function () {
    const $triggerButton = $('#wbs-trigger-ASUpkUmx2bldoNkFmR__eu_widerruf_button_button_mpm9Dz');

    attempts++;

    if ($triggerButton.length) {
      clearInterval(timer);
      $triggerButton.trigger('click');
      return;
    }

    if (attempts >= 20) {
      clearInterval(timer);
      console.warn('#wb-trigger-btn not found');
    }
  }, 100);
});

/** BUTTON CUSTOM */

    document.addEventListener('click', function (e) {
    const summary = e.target.closest(
        'aside#main-collection-filters > div .facets__disclosure > summary'
    );

    if (!summary) return;

    e.preventDefault();

    const currentDetails = summary.parentElement;

    // Close all other filters
    document
        .querySelectorAll(
        'aside#main-collection-filters > div .facets__disclosure'
        )
        .forEach(details => {
        if (details !== currentDetails) {
            details.removeAttribute('open');
        }
        });

    // Toggle current
    if (currentDetails.hasAttribute('open')) {
        currentDetails.removeAttribute('open');
    } else {
        currentDetails.setAttribute('open', '');
    }
    });
    $('.has_dropdown p.footer-block__heading.inline-richtext').click(function (e) { 
        e.preventDefault();
        $(this).toggleClass('active');
    });
    function slider_mobile() {
        if($(window).width() <= 949){
        $(".announcement-bar .grid").flickity({
            pageDots: false,
            freeScroll: false,
            wrapAround: true,
            prevNextButtons: true,
            autoPlay: 5000,
            groupCells: false,
            cellAlign: 'left',
        });
        
        }
    }
    $(document).ready(slider_mobile);
    $(window).on('resize', function() {
        slider_mobile();
    });
    var $markenSlider = $(".column_marken .multicolumn-list").flickity({
        pageDots: false,
        freeScroll: false,
        wrapAround: true,
        prevNextButtons: true,
        autoPlay: 5000,
        groupCells: false,
        cellAlign: 'center',
    });

    // TZN fix: Flickity absolutely-positions each cell, so cells only take the
    // height of their own content (no CSS-only equal-height / flex fix is possible
    // once Flickity has taken over). We measure the tallest card and the tallest
    // description text block and apply those heights explicitly so every brand's
    // last sentence lands on the same line, and the "Zur Marke" buttons align too.
    function equalizeMarkenCardHeights() {
        var $cards = $(".column_marken .multicolumn-card");
        var $texts = $(".column_marken .multicolumn-card__info .rte");
        if (!$cards.length) return;

        // Reset first so measurements reflect natural content height.
        $cards.css("height", "auto");
        $texts.css("height", "auto");

        // Equalize the description text blocks so every brand's last sentence
        // aligns on the same height.
        var maxTextHeight = 0;
        $texts.each(function () {
            var h = $(this).outerHeight();
            if (h > maxTextHeight) maxTextHeight = h;
        });
        if (maxTextHeight > 0) {
            $texts.css("height", maxTextHeight + "px");
        }

        // Equalize the overall card height so the buttons align too.
        var maxCardHeight = 0;
        $cards.each(function () {
            var h = $(this).outerHeight();
            if (h > maxCardHeight) maxCardHeight = h;
        });
        $cards.css("height", maxCardHeight + "px");

        if ($markenSlider.data && $markenSlider.data('flickity')) {
            $markenSlider.flickity('resize');
        }
    }
    $(window).on('load', equalizeMarkenCardHeights);
    $(window).on('resize', equalizeMarkenCardHeights);
    setTimeout(equalizeMarkenCardHeights, 300);
    setTimeout(equalizeMarkenCardHeights, 1000);

// slider pdp
$("ul.product-single__thumbnails").flickity({
      pageDots: false,
    // freeScroll: false,
    // wrapAround: true,
    prevNextButtons: false,
    autoPlay: false,
    groupCells: true,
    cellAlign: 'left',
    asNavFor: '.product-single__gallery'
});

$('.product-single__gallery').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: true,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
    }); 
  
  $('.product-single__gallery').on('change.flickity', function(event, index) {
      var $thumbnails = $('.product-single__thumbnails li');
      $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
      $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
  });
  $('.product-single__thumbnails li').first().addClass('active');
  
  // Thumbnail click event to change the gallery image
  $('.product-single__thumbnails li').on('click', function() {
      var index = $(this).index();
      $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
  });
  // slider pdp


    // $('.dropdown-winery-btn').click(function (e) { 
    //     e.preventDefault();
    //     $(this).toggleClass('active');
    // });

     ///// Tab Faq
    $(document).on('click','.acctab_title', function(e){
        if($(window).width() >= 768){
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }else{
        $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
            // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }
    });
    $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
        $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
    });
    $('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        }
        else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });
    
});


//price custom
class PriceRange1 extends HTMLElement {
    connectedCallback() {
      this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
      this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
      this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
      this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
  
      // Event listeners for text input focus and change
      this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
      this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());
  
      this.textInputLowerBound.addEventListener("change", (event) => {
        const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
        event.target.value = newValue;
        this.rangeLowerBound.value = newValue;
        this.updateRangeStyles();
      });
  
      this.textInputHigherBound.addEventListener("change", (event) => {
        const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
        event.target.value = newValue;
        this.rangeHigherBound.value = newValue;
        this.updateRangeStyles();
      });
  
      // Event listeners for range slider change and input
      this.rangeLowerBound.addEventListener("change", (event) => {
        this.textInputLowerBound.value = event.target.value;
        this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeHigherBound.addEventListener("change", (event) => {
        this.textInputHigherBound.value = event.target.value;
        this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeLowerBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
        this.textInputLowerBound.value = event.target.value;
        this.updateRangeStyles();
      });
  
      this.rangeHigherBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
        this.textInputHigherBound.value = event.target.value;
        this.updateRangeStyles();
      });
    }
  
    updateRangeStyles() {
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
    }
}
window.customElements.define("price-range1", PriceRange1); 

